import * as React from 'react';
import React__default from 'react';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var _excluded = ["color", "size", "style"];
var Icon = (function (SvgComponent) {
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var _props$color = props.color,
        color = _props$color === void 0 ? 'currentColor' : _props$color,
        _props$size = props.size,
        size = _props$size === void 0 ? '1em' : _props$size,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        otherProps = objectWithoutPropertiesLoose(props, _excluded);

    return /*#__PURE__*/React__default.createElement(SvgComponent, _extends_1({
      ref: ref,
      fill: color,
      width: size,
      height: size,
      style: _extends_1({}, style)
    }, otherProps));
  });
});

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M232.96 177.024l603.307 603.35L791.04 825.6 187.69 222.293l45.227-45.226zm2.048 152.875l45.27 45.312-1.707 1.45C238.976 412.075 200.192 457.045 162.176 512 272.128 670.848 388.48 746.667 512 746.667A301.653 301.653 0 00628.267 723.2l48.341 48.341A368 368 0 01512 810.667c-157.099 0-299.307-99.542-426.667-298.667 47.787-74.71 97.707-135.424 149.675-182.101zM512 213.333c157.099 0 299.307 99.542 426.667 298.667-44.374 69.419-90.582 126.72-138.582 171.947l-45.226-45.27C791.21 604.715 826.837 562.56 861.824 512 751.872 353.152 635.52 277.333 512 277.333c-34.133 0-67.797 5.803-100.864 17.536l-49.323-49.237A365.952 365.952 0 01512 213.333zM387.413 482.39l154.198 154.155a128 128 0 01-154.155-154.155zM512 384a128 128 0 01127.53 139.221L500.78 384.427A129.707 129.707 0 01512 384z"
});

function SvgEyeClose(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "eyeClose_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    ref: svgRef
  }, props), _ref, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);

var ForwardIcon = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(ForwardRef, _extends_1({}, props, {
    ref: ref
  }));
});
var KuFoxIcons = Icon(ForwardIcon);
KuFoxIcons.displayName = 'EyeCloseOutlined';

export default KuFoxIcons;
